import { Injectable } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { BehaviorSubject, fromEvent, map, merge, Observable, of } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  /**
   * Get an Observable of the application network status.<br/>
   * <b>true</b> => online <br/>
   * <b>false</b> => offline
   */
  public connection$: Observable<boolean>

  /**
   * Get the current status of the network.<br/>
   * <b>true</b> => online <br/>
   * <b>false</b> => offline
   */
  public get connected(): boolean {
    return this.connectionSubject.getValue()
  }

  private connectionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  constructor() {
    this.connection$ = this.connectionSubject.asObservable()

    merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false)),
    )
      .pipe(takeUntilDestroyed())
      .subscribe((connected: boolean) => {
        this.connectionSubject.next(connected)
      })
  }
}
